import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';

@Component({
  selector: 'app-busqueda-paginador-avanzado',
  standalone: true,
  imports: [CommonModule, FormsModule, ButtonModule, DropdownModule],
  template: `
    <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2 p-3 border-t dark:border-gray-700">
      <div class="text-gray-600 dark:text-gray-400 text-sm">
        Pagina {{ currentPage() }} de {{ totalPages() }}
      </div>
      <div class="flex gap-2 items-center flex-wrap">
        <label class="text-sm text-gray-600 dark:text-gray-400">Registros:</label>
        <p-dropdown
          [options]="pageSizeOptions()"
          [ngModel]="selectedPageSize()"
          (ngModelChange)="pageSizeChange.emit($event)"
          styleClass="w-full sm:w-24 max-w-full"
          appendTo="body"
        />
        <p-button
          icon="pi pi-angle-double-left"
          severity="secondary"
          size="small"
          styleClass="min-w-[44px] min-h-[44px]"
          [disabled]="currentPage() <= 1"
          (onClick)="first.emit()"
        />
        <p-button
          icon="pi pi-angle-left"
          severity="secondary"
          size="small"
          styleClass="min-w-[44px] min-h-[44px]"
          [disabled]="!hasPrevious()"
          (onClick)="previous.emit()"
        />

        <div class="flex gap-1" *ngIf="visiblePages().length > 0">
          <ng-container *ngFor="let pageNum of visiblePages(); trackBy: trackPage">
            <span class="px-2 py-1 text-gray-500 dark:text-gray-400" *ngIf="pageNum === 0">...</span>
            <p-button
              *ngIf="pageNum !== 0"
              [label]="pageNum.toString()"
              severity="secondary"
              size="small"
              styleClass="min-w-[44px] min-h-[44px]"
              [text]="pageNum !== currentPage()"
              [style]="{ color: pageNum === currentPage() ? '#2563eb' : '' }"
              (onClick)="selectPage.emit(pageNum)"
            />
          </ng-container>
        </div>

        <p-button
          icon="pi pi-angle-right"
          severity="secondary"
          size="small"
          styleClass="min-w-[44px] min-h-[44px]"
          [disabled]="!hasNext()"
          (onClick)="next.emit()"
        />
        <p-button
          icon="pi pi-angle-double-right"
          severity="secondary"
          size="small"
          styleClass="min-w-[44px] min-h-[44px]"
          [disabled]="currentPage() >= totalPages()"
          (onClick)="last.emit()"
        />
      </div>
    </div>
  `
})
export class BusquedaPaginadorAvanzadoComponent {
  currentPage = input.required<number>();
  totalPages = input.required<number>();
  hasPrevious = input.required<boolean>();
  hasNext = input.required<boolean>();
  pageSizeOptions = input.required<number[]>();
  selectedPageSize = input.required<number>();
  visiblePages = input<number[]>([]);

  pageSizeChange = output<number>();
  first = output<void>();
  previous = output<void>();
  next = output<void>();
  last = output<void>();
  selectPage = output<number>();

  trackPage(_index: number, pageNum: number): number {
    return pageNum;
  }
}
